import styled, { css } from 'styled-components'

const spacing = .8
const container = 1137
const columns = 12
const containerSpacing = spacing * 2

const breakPoints = [
    769,
]

export const Container = styled.div`
    width: 100%;
    max-width: ${container}px;
    clear: both;

    margin-right: auto;
    margin-left: auto;

    box-sizing: border-box;
    &:before,
    &:after {
        content: " ";
        display: table;
    }
    &:after {
        clear: both;
    }

    padding-left: ${containerSpacing}rem;
    padding-right: ${containerSpacing}rem;

    ${props => props.fluid && css`max-width: 100%;` }
`

export const Row = styled.div`
    min-width: 100%;
    display: flex;
    flex-wrap: wrap;

    height: auto;
    box-sizing: border-box;

    ${props => SpacingHelper(props)}

    ${props => {
        let justifyContent = props.justifyContent ? props.justifyContent.split(' ') : []
        let alignItems = props.alignItems ? props.alignItems.split(' ') : []
        let gutter = props.gutter ? props.gutter.split(' ') : ["1"]
        return renderBreakPoints(k => css`
            ${justifyContent[k] && css `justify-content: ${justifyContent[k]};`}
            ${alignItems[k] && css `align-items: ${alignItems[k]};`}
            ${gutter[k] && renderGutter(gutter[k])}
        `)
    }}
`

export const Col = styled.div`
    flex-basis: 0;
    flex-grow: 1;
    box-flex: 1;
    max-width: 100%;
    min-height: 1px;
    box-sizing: border-box;
    position: relative;

    ${props => SpacingHelper(props)}

    ${props => {
        let grow = props.grow ? props.grow.split(' ') : []
        let text = props.text ? props.text.split(' ') : []
        let order = props.order ? props.order.split(' ') : []
        let size = props.size ? props.size.split(' ') : []
        return renderBreakPoints(k => css`
                ${size[k] && renderColSize(size[k])}
                ${grow[k] && css `flex-grow: ${grow[k]};`}
                ${text[k] && css `text-align: ${text[k]};`}
                ${order[k] && css `order: ${order[k]};`}
            `
        )
    }}
`

function SpacingHelper(props) {
    return css`
        ${props.mb && css` margin-bottom: ${parseFloat(props.mb) * spacing}rem; `}    
        ${props.mt && css` margin-top: ${parseFloat(props.mt) * spacing}rem; `}
        ${props.pb && css` padding-bottom: ${parseFloat(props.pb) * spacing}rem; `}    
        ${props.pt && css` padding-top: ${parseFloat(props.pt) * spacing}rem; `}
    `
}

function renderBreakPoints(render) {
    return css`
        ${render(0)}
        
        ${breakPoints.map((bp, k) => {
            return css`
                @media only screen and (min-width: ${bp}px) {
                    ${render(k+1)}
                }
            `
        })}
    `
}

function renderColSize(size) {
    if(size === "hidden") {
        return css `display: none;`
    }

    if(size === "auto") {
        return css `
            flex: 0 0 auto;
            width: auto;
            max-width: none;
        `
    }

    let total = columns

    if(size.match(/\//)) {
        let colSize = size.split("/")
        size = colSize[0]
        total = parseInt(colSize[1], 10)
    }
    
    size = parseInt(size, 10)
    let percent = 100/total * size
    
    return css `
        display: block;
        width: ${percent}%;
        flex: 0 0 ${percent}%;
    `
}

function renderGutter(gutter) {
    gutter = parseFloat(gutter)

    return css`
        margin-left: -${spacing*gutter}rem;
        margin-right: -${spacing*gutter}rem;

        ${Col} {
            padding-left: ${spacing*gutter}rem;
            padding-right: ${spacing*gutter}rem;
        }
    `
}


// WEBPACK FOOTER //
// ./src/SPRINTA/v3/Grid/index.js